import React from 'react';
import { useLocation } from 'react-router-dom';
import { KatButton, KatColumn, KatRow } from '@amzn/katal-react';
import { contactUsFormUrls, ContactUsType, CountryCode, getPageViewForSignInPageUrl, PageViewPNF } from '../urls-config';
import { BrandRegistryInfoAlertBox } from './BrandRegistryInfoAlertBox';
import { AuthenticationState } from './hooks/useTrimContext';
import { usePNFTranslation } from 'src/common/helpers';

interface PnfSignInPageProps {
  authenticationState?: AuthenticationState ;
  domainCountryCode: CountryCode;
}

const PnfSignInPage: React.FC<PnfSignInPageProps> = (props: PnfSignInPageProps) => {
  const t = usePNFTranslation();
  const { authenticationState, domainCountryCode } = props;

  const location = useLocation();

  const pageView = getPageViewForSignInPageUrl(location.pathname);

  const contactUsFormUrlSeller = contactUsFormUrls(domainCountryCode, ContactUsType.SELLER);
    const contactUsFormUrlBuyer = contactUsFormUrls(domainCountryCode, ContactUsType.BUYER);
    const ipLinkUrl = contactUsFormUrls(domainCountryCode, ContactUsType.IP);
    const publicNoticeFormInstructions2 = t('public-notice-form-instructions-2', {
      contactUsForm: (chunk: string) =>
        <a
          href={contactUsFormUrlSeller}
          id="pnf-contact-us-form"
          target="_blank"
        >
          {chunk}
        </a>,
    });
    const publicNoticeFormInstructions3 = t('public-notice-form-instructions-3', {
      contactUsForm: (chunk: string) =>
        <a
          href={contactUsFormUrlBuyer}
          id="pnf-contact-us-form-buyer"
          target="_blank"
        >
          {chunk}
        </a>,
    });
    const weDoNotEnforceInstructions2 = t('public-notice-form-we-do-not-enforce-instructions-2', {
      contactUsFormLink: (chunk: string) =>
        <a
          href={contactUsFormUrlSeller}
          id="pnf-not-enforce-contact-us-form"
          target="_blank"
        >
          {chunk}
        </a>,
    });
    const weDoNotEnforceInstructions5 = t('public-notice-form-we-do-not-enforce-instructions-5', {
      ipLink: (chunk: string) =>
        <a
          href={ipLinkUrl}
          id="pnf-ip-link"
          target="_blank"
        >
          {chunk}
        </a>,
    });

  const handleSignInClick = () => {
    window.location.href = authenticationState?.signInUrl || '';
  };
  return (
    <div className="page-padding">
      {/* Page container for page level padding */}
      <KatRow className="d-flex justify-content-between">
        <KatColumn lg={6} md={6} xs={6}>
          <KatRow className="pt-4">
            <h1>
              {PageViewPNF.RETRACT === pageView
                ? t('pnf-retract-form-title')
                : t('public-notice-form-header')}
            </h1>
          </KatRow>
          <KatRow className="pt-2">
            <h2>{t('public-notice-form-required-sign-in-auth-title')}</h2>
          </KatRow>
          <KatRow>
            <p>
              {PageViewPNF.RETRACT === pageView
                ? t('pnf-retract-signin-instructions')
                : t('public-notice-form-submit-infringement-report')}
            </p>
          </KatRow>
          <KatRow className="align-items-center">
            <KatButton
              id="pnf-website-sign-in-button"
              variant="primary"
              onClick={handleSignInClick}
            >
              {t('public-notice-form-sign-in-button')}
            </KatButton>
            <span className="ms-1" id="create-account">
              {t('public-notice-form-required-sign-in-new-to-amazon')}
              <a className="ms-1" href={authenticationState?.registerUrl}>
                {t('public-notice-form-required-sign-in-create-an-account')}
              </a>
            </span>
          </KatRow>
          {
            PageViewPNF.REPORT === pageView &&
            <>
              <KatRow className="pt-4">
                <h2>{t('public-notice-form-instructions-title')}</h2>
                <span>{t('public-notice-form-instructions-1')}</span>
                <ul>
                  <li>{publicNoticeFormInstructions2}</li>
                  <li>{publicNoticeFormInstructions3}</li>
                </ul>
              </KatRow>
              <KatRow className="pt-2">
                <h2>{t('public-notice-form-we-do-not-enforce-title')}</h2>
                <p>
                  {t('public-notice-form-we-do-not-enforce-instructions-1', {
                    b: (chunk: string) => <b>{chunk}</b>
                  })}
                </p>
                <p>
                  {weDoNotEnforceInstructions2}
                </p>
                <p>{t('public-notice-form-we-do-not-enforce-instructions-3')}</p>
                <p>
                  {t('public-notice-form-we-do-not-enforce-instructions-4', {
                    b: (chunk: string) => <b>{chunk}</b>
                  })}
                </p>
                <p>
                  {weDoNotEnforceInstructions5}
                </p>
              </KatRow>
            </>
          }
          {
            PageViewPNF.RETRACT === pageView &&
              <KatRow className="pt-4">
                <h2>{t('pnf-retract-about')}</h2>
                <p>{t('pnf-retract-info')}</p>
              </KatRow>
          }
        </KatColumn>
        <KatColumn lg={4} md={4} xs={4}>
          <BrandRegistryInfoAlertBox domainCountryCode={domainCountryCode} />
        </KatColumn>
      </KatRow>
    </div>
  );
};
export default PnfSignInPage;
